'use client';

import {
  cancelFrame,
  frame,
  useMotionValueEvent,
  type MotionValue,
} from 'motion/react';
import { useCallback, useEffect } from 'react';
import { useSkyShell } from '../skyShellContext';

export const useCompassSky = (bearing: MotionValue<number>) => {
  const { ready, setSkyState } = useSkyShell();

  const updateYaw = useCallback(() => {
    setSkyState({ yaw: 270 - bearing.get() });
  }, [bearing, setSkyState]);

  useMotionValueEvent(bearing, 'change', () => {
    if (ready) frame.update(updateYaw);
  });

  useEffect(() => {
    if (ready) frame.update(updateYaw);
    return () => cancelFrame(updateYaw);
  }, [ready, updateYaw]);
};
